module.exports = __webpack_public_path__ + "static/img/07scoreBg.5e74c16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/06sleep/07scoreBg.png
// module id = RVb0
// module chunks = 0